import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNav, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { ProfileHeaderComponent } from 'src/app/common/profile-header/profile-header.component';
import { SwooshComponent } from 'src/app/common/ui-elements/swoosh.component';
import { TeamMember } from '../../app.models';
import { AppService } from '../../app.service';
import { ApplicationInsightsService } from '../../application-insights.service';
import { TeamMemberBlindSpotsComponent } from './blind-spots/team-member-blind-spots.component';
import { TeamMemberCharacteristicsComponent } from './characteristics/team-member-characteristics.component';
import { TeamMemberStrengthsComponent } from './strengths/team-member-strengths.component';

@Component({
  selector: 'app-team-member',
  templateUrl: './team-member.component.html',
  styleUrls: ['./team-member.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TeamMemberStrengthsComponent,
    TeamMemberBlindSpotsComponent,
    SwooshComponent,
    ProfileHeaderComponent,
    TeamMemberCharacteristicsComponent,
    NgbNav,
    NgbNavOutlet,
  ],
})
export class TeamMemberComponent implements OnInit {
  swooshText = '';
  swooshRoute = '/team';
  teamMember: TeamMember;
  teamMemberType: string;
  isMobileLayout: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private applicationInsightsService: ApplicationInsightsService,
  ) {
    this.isMobileLayout = window.innerWidth < 768;
  }
  ngOnInit() {
    let id = +this.route.snapshot.paramMap.get('id');

    if (id === 0) this.router.navigate(['/results']);

    window.onresize = () => (this.isMobileLayout = window.innerWidth < 768);

    let teamInfo = this.appService.getTeamInfo();

    try {
      this.teamMember = teamInfo.teamMembers.find((obj) => {
        return obj.memberId === id;
      });

      this.teamMemberType = this.teamMember.mbtiType;
    } catch (exception) {
      this.applicationInsightsService.logException(exception as Error);
      return;
    }
  }
}
